import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    inputSKChannel = new Subject()
    periodDetailChannel = new Subject()
    exportUsulanChannel = new Subject()
    exportLampiranChannel = new Subject()
    processChannel = new Subject()
    downloadDraftSKChannel = new Subject()
    createSKCChannel = new Subject()
    listSKCChannel = new Subject()
    downloadSKCChannel = new Subject()
    repository = new IndexRepository()
    generateChannel = new Subject()
    signatoriesChannel = new Subject()

    constructor() {
        this.periodDetailChannel.next({status: apiResponse.INITIAL})
        this.exportUsulanChannel.next({status: apiResponse.INITIAL})
        this.exportLampiranChannel.next({status: apiResponse.INITIAL})
        this.processChannel.next({status: apiResponse.INITIAL})
        this.downloadDraftSKChannel.next({status: apiResponse.INITIAL})
        this.inputSKChannel.next({status: apiResponse.INITIAL})

        this.createSKCChannel.next({status: apiResponse.INITIAL})
        this.listSKCChannel.next({status: apiResponse.INITIAL})
        this.downloadSKCChannel.next({status: apiResponse.INITIAL})
        this.generateChannel.next({status: apiResponse.INITIAL})
        this.signatoriesChannel.next({status: apiResponse.INITIAL})
    }

    fetchInputSK = async (query) => {
        try {
            this.inputSKChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInputSK(query).then((result) => {
                this.inputSKChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inputSKChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchPeriodDetail = async (query) => {
        try {
            this.periodDetailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchPeriodDetail(query).then((result) => {
                this.periodDetailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.periodDetailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchExportUsulan = async (query) => {
        try {
            this.exportUsulanChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportUsulan(query).then((result) => {
                this.exportUsulanChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportUsulanChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchExportLampiran = async (query) => {
        try {
            this.exportLampiranChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportLampiran(query).then((result) => {
                this.exportLampiranChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportLampiranChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchProcess = async (query) => {
        try {
            this.processChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchProcess(query).then((result) => {
                this.processChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.processChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
    fetchGenerate = async (query) => {
        try {
            this.generateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchGenerate(query).then((result) => {
                this.generateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.generateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
    fetchDownloadDraftSK = async (query) => {
        try {
            this.downloadDraftSKChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDownloadDraftSK(query).then((result) => {
                this.downloadDraftSKChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.downloadDraftSKChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchCreateSKC = async (query) => {
        try {
            this.createSKCChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreateSKC(query).then((result) => {
                this.createSKCChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createSKCChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchListSKC = async (query) => {
        try {
            this.listSKCChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListSKC(query).then((result) => {
                this.listSKCChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listSKCChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchDownloadSKC = async (query) => {
        try {
            
            this.downloadSKCChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDownloadSKC(query).then((result) => {
                this.downloadSKCChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.downloadSKCChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
    
    fetchSignatories = async (query) => {
        try {
            
            this.signatoriesChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchSignatories(query).then((result) => {
                this.signatoriesChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.signatoriesChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
}

export default IndexBloc